// extracted by mini-css-extract-plugin
export default {"block":"Vc","image":"Wc","item":"Xc","error":"Yc"};